module.exports = __webpack_public_path__ + "img/Uzbekistan.6c30c825.svg";